<template>
    <div id="checkout-page">
		<div class="container" v-if="!isCargandoEvento && !isCargandoTransaccion && !expiroTiempo">
        	<div class="checkout-main">
				<TransactionCountdown v-if="transaccion && transaccion.TransaccionFechaFin" :trnfechafin="transaccion.TransaccionFechaFin" @expirotiempo="expiracionTiempo()" class="countdown" />
				<div class="checkout-main-top" v-if="!loggedIn">
					<div class="checkout-main-top-left" v-if="isCompletable">
						<span class="title">Información del comprador</span>
						<!-- <p>Completa los datos del comprador para realizar tu compra como invitado, o sino puedes <span class="iniciar-sesion" @click.prevent="logIn()">iniciar sesión</span>.</p> -->
						<p>Completa los datos del comprador para realizar tu compra como invitado.</p>
					</div>
					<div class="checkout-main-top-left" v-else>
						<span class="title">Resumen de tus tickets</span>
					</div>
				</div>
				<div class="checkout-main-comprador" v-if="!loggedIn">
					<div class="comprador">
						<div class="comprador-row-nominado">
							<div class="comprador-row">
								<div class="input-group">
									<label for="compradorNombre">Nombre</label>
									<input type="text" name="compradorNombre" id="compradorNombre" v-model="comprador.nombre">
								</div>
							</div>
							<div class="comprador-row">
								<div class="input-group">
									<label for="compradorApellido">Apellido</label>
									<input type="text" name="compradorApellido" id="compradorApellido" v-model="comprador.apellido">
								</div>
							</div>
							<div class="comprador-row">
								<div class="input-group">
									<label for="compradorDocumento">Documento</label>
									<div class="input-group-aux">
										<select name="compradorDocumentoTipo" id="compradorDocumentoTipo" v-model="comprador.documentoTipo">
											<option :value="td.valor" v-for="td in tipoDocumentos" :key="td.valor">{{ td.descripcion }}</option>
										</select>
										<input type="text" name="compradorDocumento" id="compradorDocumento" v-model="comprador.documento">
									</div>
								</div>
							</div>
							<div class="comprador-row">
								<div class="input-group">
									<label for="compradorEmail">Correo electrónico</label>
									<input type="email" name="compradorEmail" id="compradorEmail" v-model="comprador.email">
								</div>
							</div>
							<div class="comprador-row">
								<div class="input-group">
									<label for="compradorEmailConfirmar">Confirmar correo electrónico</label>
									<input type="email" name="compradorEmailConfirmar" id="compradorEmailConfirmar" v-model="comprador.emailConfirmar" @paste.prevent>
								</div>
							</div>
							<div class="comprador-row comprador-row-alerta-datos">
								<div class="comprador-alerta">
									<i class='bx bxs-info-circle'></i>
									<span>¡Atención! Asegúrese que el correo electrónico sea correcto, ya que los tickets serán enviados a esa casilla.</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="checkout-main-top">
					<div class="checkout-main-top-left" v-if="isCompletable">
						<span v-if="Number(transaccion.TransaccionCantidad) > 1" class="title">Información de los espectadores</span>
						<span v-else class="title">Información del espectador</span>
						<p v-if="Number(transaccion.TransaccionCantidad) > 1">Debes completar los datos para cada uno de los espectadores.</p>
						<p v-else>Completa los datos del espectador.</p>
					</div>
					<div class="checkout-main-top-left" v-else>
						<span class="title">Resumen de tus tickets</span>
					</div>
					<div class="checkout-main-top-right">
						<!-- <TransactionCountdown v-if="transaccion && transaccion.TransaccionFechaFin" :trnfechafin="transaccion.TransaccionFechaFin" @expirotiempo="expiracionTiempo()" /> -->
					</div>
				</div>
				<div class="checkout-main-content">
					<div class="ticket" :id="'tn' + (index + 1)" v-for="(ticket, index) in tickets" :key="ticket.Id">
						<div class="recalculando-segmento" v-if="ticket.RecalculandoSegmento">
							<clip-loader :color="'var(--color-darker)'" :size="'32px'"></clip-loader>
						</div>
						<div class="ticket-top">
							<div class="ticket-top-left">
								<span class="ticket-text">Ticket</span>
								<span class="ticket-id">#{{ ticket.Id }}</span>
							</div>
							<div class="ticket-top-right" :style="[tickets.length > 1 ? {'width': 'calc(100% - 74px)'} : {'width': '100%'}]">
								<span class="sector" v-if="ticket.SegmentoId > 0">{{ ticket.SegmentoNombre }}</span>
								<span class="sector-info" v-if="ticket.EventoSegmentoInfo && ticket.SegmentoId > 0">{{ ticket.EventoSegmentoInfo }}</span>
								<div class="sector-calcular-aclarar" v-if="!ticket.SegmentoId || ticket.SegmentoId <= 0">Completa los datos para calcular el precio del ticket del espectador.</div>
							</div>
						</div>
						<!-- <div class="ticket-row" :class="transaccion.TransaccionEventoTribunaNombre.toUpperCase().trim() !== transaccion.TransaccionEventoSectorDescripcion.toUpperCase().trim() ? 'row-multiple' : ''">
							<div class="input-group">
								<label v-if="evento.Escenario.EscenarioConfiguracionTribunaAlias.trim()">{{ evento.Escenario.EscenarioConfiguracionTribunaAlias.trim() }}</label>
								<label v-else>Acceso</label>
								<span class="tribuna-nombre">{{ transaccion.TransaccionEventoTribunaNombre.trim() }}</span>
							</div>
							<div class="input-group" v-if="transaccion.TransaccionEventoTribunaNombre.toUpperCase().trim() !== transaccion.TransaccionEventoSectorDescripcion.toUpperCase().trim()">
								<label v-if="evento.Escenario.EscenarioConfiguracionSectorAlias.trim()">{{ evento.Escenario.EscenarioConfiguracionSectorAlias.trim() }}</label>
								<label v-else>Sector</label>
								<span class="tribuna-nombre">{{ transaccion.TransaccionEventoSectorDescripcion.trim() }}</span>
							</div>
						</div> -->
						<div class="ticket-row-nominado" v-if="evento.Evento.EventoTicketNominado">
							<div class="ticket-row" v-if="preseleccionYo && loggedIn">
								<button @click="promptPreseleccionOpen(index)" class="preseleccionar-button"><i class='bx bx-body'></i>Preseleccionar persona</button>
							</div>
							<div class="ticket-row ticket-row-alerta-datos" v-else-if="loggedIn">
								<div class="preseleccion-alerta">
									<i class='bx bxs-info-circle'></i>
									<span>¡Atención! Complete <router-link :to="{ name: 'informacion-personal' }" target="_blank">aquí</router-link> sus datos personales para poder ingresarlos rápidamente en una futura compra. </span>
								</div>
							</div>
							<div class="ticket-row">
								<div class="input-group">
									<label :for="'nombre-' + ticket.Id">Nombre</label>
									<input type="text" :name="'nombre-' + ticket.Id" :id="'nombre-' + ticket.Id" v-model="ticket.PersonaNombre" :tabindex="(ticket.TabIndexContador - (eventoCampos.length + 2))">
								</div>
							</div>
							<div class="ticket-row">
								<div class="input-group">
									<label :for="'apellido-' + ticket.Id">Apellido</label>
									<input type="text" :name="'apellido-' + ticket.Id" :id="'apellido-' + ticket.Id" v-model="ticket.PersonaApellido" :tabindex="(ticket.TabIndexContador - (eventoCampos.length + 1))">
								</div>
							</div>
							<div class="ticket-row">
								<div class="input-group">
									<label :for="'documento-' + ticket.Id">Documento</label>
									<div class="input-group-aux">
										<select :name="'tipodoc-' + ticket.Id" :id="'tipodoc-' + ticket.Id" v-model="ticket.PersonaDocumentoTipoId" @change="calcularSegmento(index)">
											<option :value="td.valor" v-for="td in tipoDocumentos" :key="td.valor">{{ td.descripcion }}</option>
										</select>
										<input type="text" :name="'documento-' + ticket.Id" :id="'documento-' + ticket.Id" v-model="ticket.PersonaDocumento" @keyup="textSearch($event, index)" :tabindex="(ticket.TabIndexContador - eventoCampos.length)">
									</div>
								</div>
							</div>
						</div>
						<div class="ticket-row-campos" v-if="eventoCampos.length > 0">
							<div class="ticket-row" v-for="(campo, index) in eventoCampos" :key="campo.CampoCod">
								<div class="input-group" v-if="(campo.CampoTipo === 'O' && campo.Opciones.length > 0) || campo.CampoTipo !== 'O'">
									<label :for="'campo-' + campo.CampoCod">{{ campo.CampoDescripcion }}</label>

									<input type="text" :name="'campo-' + campo.CampoCod" :id="'campo-' + campo.CampoCod" v-model="ticket.Campos[index].TicketCampoValor" v-if="campo.CampoTipo === 'T'" :tabindex="ticket.TabIndexContador - eventoCampos.length + index + 1">
									<input type="text" :name="'campo-' + campo.CampoCod" :id="'campo-' + campo.CampoCod" v-model="ticket.Campos[index].TicketCampoValor" v-if="campo.CampoTipo === 'N'" :tabindex="ticket.TabIndexContador - eventoCampos.length + index + 1" @keypress="soloNumeros">
									<select :name="'campo-' + campo.CampoCod" :id="'campo-' + campo.CampoCod" v-model="ticket.Campos[index].TicketCampoValor" v-if="campo.CampoTipo === 'O'" :tabindex="ticket.TabIndexContador - eventoCampos.length + index + 1">
										<option :value="opcion.CampoOpcionId" v-for="opcion in campo.Opciones" :key="opcion.CampoOpcionId">{{ opcion.CampoOpcionValor }}</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<aside>
				<div class="aside-wrapper">
					<div class="aside-top" :style="{ 'background-image': 'url(' + evento.Evento.EventoFotoPrincipal + ')' }">
						<span class="evento-title">{{ evento.Evento.EventoNombre }}</span>
						<div class="aside-top-info">
							<img class="evento-foto" :src="evento.Evento.EventoFotoPrincipal" :alt="evento.Evento.EventoNombre">
							<div class="aside-top-info-right">
								<span class="evento-info-categoria">{{ evento.Categorias.EventoCategoriaNombre }}</span>
								<span class="evento-info-fecha">{{ evento.Fecha.EventoFechaHoraEscrita }}</span>
								<span class="evento-info-escenario">{{ evento.Escenario.EscenarioNombre }}</span>
							</div>
						</div>
					</div>
					<div class="aside-main">
						<div class="aside-row">
							<span class="resumen-text">Resumen de tu compra</span>
						</div>
						<div class="aside-row">
							<span class="sector-text">{{ transaccion.TransaccionEventoSectorDescripcion }}</span>
						</div>
						<div class="aside-row">
							<span class="sector-text-info" v-if="transaccion.TransaccionEventoSectorInfo">{{ transaccion.TransaccionEventoSectorInfo }}</span>
						</div>
						<div class="aside-row aside-row-item" v-for="segmento in segmentosElegidos" :key="segmento.SegmentoId">
							<span class="item">{{ segmento.SegmentoNombre }}</span>
							<span class="item-monto">{{ segmento.SegmentoCantidad }}x {{ transaccion.MonedaSimbolo }}{{ segmento.ListaMonto.toString().replace('.00', '') }}</span>
						</div>
						<div class="aside-row">
							<div class="divider"></div>
						</div>
						<div class="aside-row aside-row-concepto">
							<div class="concepto-subtotal">Subtotal</div>
							<div class="monto-subtotal" v-if="isSegmentosCompletos || evento.Evento.EventoSegmentoElegible">{{ transaccion.MonedaSimbolo }}{{ transaccionSubtotal.toString().replace('.00', '') }}</div>
							<div class="monto-subtotal" v-if="!isSegmentosCompletos && !evento.Evento.EventoSegmentoElegible">-</div>
						</div>
						<div class="aside-row aside-row-concepto">
							<div class="concepto-comision">Comisión</div>
							<div class="monto-comision" v-if="isSegmentosCompletos || evento.Evento.EventoSegmentoElegible">{{ transaccion.MonedaSimbolo }}{{ transaccionComision.toString().replace('.00', '') }}</div>
							<div class="monto-comision" v-if="!isSegmentosCompletos && !evento.Evento.EventoSegmentoElegible">-</div>
						</div>
						<div class="aside-row aside-row-concepto-total">
							<div class="concepto-total">Total</div>
							<div class="monto-total" v-if="isSegmentosCompletos || evento.Evento.EventoSegmentoElegible">{{ transaccion.MonedaSimbolo }}{{ transaccionTotal.toString().replace('.00', '') }}</div>
							<div class="monto-total" v-if="!isSegmentosCompletos && !evento.Evento.EventoSegmentoElegible">-</div>
						</div>
						<div class="aside-row">
							<div v-if="isReadyToPay" id="walletBrick_container"></div>
							<button @click.prevent="emitir('C')" v-else-if="datosCompletos && transaccionSubtotal === 0 && !emitiendo">Canjear tickets</button>
							<button disabled="disabled" v-else-if="emitiendo">Emitiendo <clip-loader class="emitiendo-loader" :color="'var(--color-darker)'" :size="'12px'"></clip-loader></button>
							<button disabled="disabled" v-else>Completa todos los datos</button>
						</div>
						<div class="aside-row aside-row-terminos">
							<span class="terminos">
								Al continuar, aceptas las <router-link :to="{ name: 'terminos-y-condiciones' }" target="_blank">Condiciones de servicio</router-link> de LineUp Tickets y reconoces que leíste nuestra <router-link :to="{ name: 'politica-de-privacidad' }" target="_blank">Política de privacidad</router-link>.
							</span>
						</div>
						<div class="aside-bottom" v-if="transaccionTotal > 0">
							<div class="aside-bottom-row">
								<div class="check-icon">
									<i class='bx bx-check' ></i>
								</div>
								<div class="aside-bottom-group">
									<span class="aside-bottom-title">Pago seguro</span>
									<span class="aside-bottom-text">Pagá de manera segura a través de MercadoPago. LineUp no almacena datos de tarjetas.</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="cancelar-transaccion" @click.prevent="cancelarTransaccionOpen()">Cancelar transacción</div>
			</aside>
		</div>
		<div class="container" v-else>
			<clip-loader v-if="!expiroTiempo" class="evento-loader" :color="'var(--color-primary)'" :size="'52px'"></clip-loader>
		</div>
		<modal name="cancelar-transaccion" class="cancelar-transaccion" transition="scale" mode="in-out" :clickToClose="false">
			<div class="cancelar-transaccion-content">
				<div class="cancelar-transaccion-main">
					<span class="atencion">¡Atención!</span>
					<span class="atencion-text">Al abandonar esta página, tus tickets dejarán de estar reservados y volverán a estar a la venta.</span>
					<span class="atencion-text">¿Estás seguro que deseas cancelar la transacción?</span>
				</div>
				<div class="buttons">
					<button class="no-quedarme" @click="$modal.hide('cancelar-transaccion')">No, quedarme aquí</button>
					<button class="si-cancelar" @click.prevent="cancelarTransaccionId(true)">Si, cancelar</button>
				</div>
			</div>
		</modal>
		<modal name="expiro-tiempo" class="expiro-tiempo" transition="scale" mode="in-out" :clickToClose="false">
			<div class="alerta">
				<i class='bx bxs-error-alt'></i>
			</div>
			<div class="expiro-tiempo-content">
				<div class="expiro-tiempo-main">
					<span class="atencion">Compra expirada</span>
					<span class="atencion-text">Hemos liberado tus entradas a la venta, ya que la transacción expiró. Vuelve a realizar el proceso de compra.</span>
				</div>
				<div class="buttons">
					<button class="no-quedarme" @click="irAEvento(transaccion.EventoId, transaccion.EventoSlug)">Volver</button>
				</div>
			</div>
		</modal>
		<modal name="promptPreseleccion" class="promptPreseleccion" transition="scale" :clickToClose="true" @closed="promptPreseleccionClosed()">
			<div class="preseleccion-close" @click="$modal.hide('promptPreseleccion')">
				<i class='bx bx-x'></i>
			</div>
			<div class="preseleccion-content" v-if="preseleccionYo">
				<div class="preseleccion-header">
					<span class="title">Elegir preselección</span>
					<p>En caso de que lo desees, puedes preseleccionar una persona para el ticket. Puede ser para tí, o para alguno de tus amigos.</p>
				</div>
				<div class="preseleccion-main">
					<div class="preseleccion preseleccion-yo" @click.prevent="elegirPreseleccion(preseleccionYo)">
						<div class="preseleccion-left">
							<span class="yo">YO</span>
						</div>
						<div class="preseleccion-right">
							<span class="nombre">{{ preseleccionYo.PersonaNombre }} {{ preseleccionYo.PersonaApellido }}</span>
							<span class="tipo-documento">{{ preseleccionYo.PersonaDocumentoTipoNombre }}</span>
							<span class="documento">{{ preseleccionYo.PersonaDocumento }}</span>
						</div>
					</div>
					<div class="divider"><span>o elige un amigo</span></div>
					<div class="amigos" v-if="preseleccionesAmigos.length > 0">
						<div class="preseleccion" v-for="preseleccion in preseleccionesAmigos" :key="preseleccion.PersonaId" @click.prevent="elegirPreseleccion(preseleccion)">
							<span class="nombre">{{ preseleccion.PersonaNombre }} {{ preseleccion.PersonaApellido }}</span>
							<span class="tipo-documento">{{ preseleccion.PersonaDocumentoTipoNombre }}</span>
							<span class="documento">{{ preseleccion.PersonaDocumento }}</span>
						</div>
					</div>
					<div class="no-amigos" v-else>
						<span class="no-amigos-span">Aún no tienes amigos. Cuando le compres la entrada a un amigo, podrás verlo aquí para facilitar futuras compras.
						</span>
					</div>
				</div>
			</div>
		</modal>
    </div>
</template>

<script>
	import axios from 'axios';
	import { mapState, mapActions }  from 'vuex';
	import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
	import TransactionCountdown from '../components/eventos/TransactionCountdown.vue'

	export default {
		data(){
			return{
				expiroTiempo: false,

				transaccion: null,
				isCargandoTransaccion: true,

				evento: null,
				eventoCampos: [],
				isCargandoEvento: true,

				// isManualLeave: false,

				tipoDocumentoCI: null,
				tipoDocumentos: [],

				/* Tickets */
				tickets: [],

				isPersonaValidarOk: false,

				emitiendo: false,
				hayError: false,
				errorMsg: '',

				/* Mercadopago */
				// preferenceId: null,
				// initPoint: null,
				usuario: null,
				preference: null,
				isOkTicketPago: false,

				/* Preselecciones */
				preseleccionYo: null,
				preseleccionesAmigos: [],
				indexTicketPreseleccion: null,

				eventoNombre: 'Be There',

				timer: undefined,

				comprador: {
					nombre: '',
					apellido: '',
					email: '',
					emailConfirmar: '',
					documento: '',
					documentoTipo: 1
				}
			}
		},
		components: {
			ClipLoader,
			TransactionCountdown
		},
		metaInfo() {
			const eventoNombre = 'Entradas para ' + this.eventoNombre
			return {
				title: eventoNombre,
				titleTemplate: '%s 🎟 LineUp Tickets'
			}
		},
		computed: {
			...mapState('AuthModule', ['user', 'loggedIn']),

			transaccionSubtotal(){
				let subTotal = 0;

				if(this.transaccion){
					this.tickets.forEach((t) => {
						if(Number(t.SegmentoId) > 0){
							// Obtener precio del segmento
							let seg = this.transaccion.Segmentos.find((s) => Number(s.SegmentoId) === Number(t.SegmentoId))
							subTotal = subTotal + parseFloat(seg.ListaMonto)
						}
					})
				}

				return subTotal
			},

			transaccionComision(){
				let comision = 0;

				if(this.transaccion){
					this.tickets.forEach((t) => {
						if(Number(t.SegmentoId) > 0){
							// Obtener precio del segmento
							let seg = this.transaccion.Segmentos.find((s) => Number(s.SegmentoId) === Number(t.SegmentoId))
							comision = comision + parseFloat(seg.Comision)
						}
					})
				}

				return comision
			},

			transaccionTotal(){
				return this.transaccionSubtotal + this.transaccionComision
			},

			compradorCompleto: function(){
				let completo = true

				if(!this.loggedIn){
					if(
						this.comprador.nombre.trim().length <= 2
						|| this.comprador.apellido.trim().length <= 2
						|| this.comprador.email.trim().length <= 5
						|| this.comprador.emailConfirmar.trim().length <= 5
						|| this.comprador.email.trim() !== this.comprador.emailConfirmar.trim()
						|| this.comprador.documento.trim().length <= 3
					){
						completo = false
					}
				} else {
					completo = true
				}

				return completo
			},

			datosCompletos: function(){
				let estanCompletos = true

				// Revisar que si no está logueado, complete los datos del comprador
				if(this.compradorCompleto === false){
					return false
				}

				// Revisar nombre, apellido, tipo de documento y documento únicamente si el ticket es nominado.
				if(this.evento && this.evento.Evento.EventoTicketNominado === true){
					for(let i=0; i<this.tickets.length; i++){
						if(
							this.tickets[i].PersonaNombre.trim().length <= 2
							|| this.tickets[i].PersonaApellido.trim().length <= 2
							|| this.tickets[i].PersonaDocumento.trim().length <= 3
							|| Number(this.tickets[i].SegmentoId) <= 0 || !this.tickets[i].SegmentoId
						){
							estanCompletos = false;
							break;
						}
					}
				}

				return estanCompletos;
			},

			isSegmentosCompletos(){
				let estanCompletos = true

				for(let i=0; i<this.tickets.length; i++){
					if(
						Number(this.tickets[i].SegmentoId) <= 0 || !this.tickets[i].SegmentoId
					){
						estanCompletos = false;
						break;
					}
				}

				return estanCompletos;
			},

			segmentosElegidos(){
				let ticketsSegmentos = [];
				let segmentoObj = null;

				// Para cada segmento, obtengo su precio, cantidad, nombre e info
				this.transaccion.Segmentos.forEach((seg) => {
					let cantidadSegmento = 0
					segmentoObj = this.transaccion.Segmentos.find((s) => Number(seg.SegmentoId) === Number(s.SegmentoId))

					this.tickets.forEach((t) => {
						if(Number(t.SegmentoId > 0) && Number(t.SegmentoId) === Number(seg.SegmentoId)){
							cantidadSegmento = cantidadSegmento + 1
						}
					})

					segmentoObj.SegmentoCantidad = cantidadSegmento
					if(cantidadSegmento > 0){
						ticketsSegmentos.push(segmentoObj)
					}
				})

				return ticketsSegmentos
			},

			isCompletable(){
				let ticketNominado = this.evento.Evento.EventoTicketNominado
				let ticketCampos = this.eventoCampos.length > 0
				return ticketNominado || ticketCampos;
			},

			isReadyToPay(){
				// if(this.transaccionSubtotal > 0 && this.datosCompletos && !this.emitiendo){
				if(this.transaccionSubtotal > 0 && this.datosCompletos){
					return true
				} else {
					if(window.walletBrickController){
						window.walletBrickController.unmount()
					}
					return false
				}
			}
		},
		watch: {
			isReadyToPay: function(readyToPay){
				if(readyToPay === true){
					const script = document.createElement('script');
					script.type = 'text/javascript';
					script.src = 'https://sdk.mercadopago.com/js/v2';
					script.addEventListener('load', ()=> {
						// const mp = new MercadoPago(process.env.VUE_APP_MERCADOPAGO_PUBLIC_KEY, {
						// 	locale: 'es-UY'
						// });

						const mp = new MercadoPago(this.transaccion.MercadoPagoCuentaPublicKey, {
							locale: 'es-UY'
						});

						const bricksBuilder = mp.bricks();

						const renderWalletBrick = async (bricksBuilder) => {
							const settings = {
								initialization: {
									redirectMode: 'self',
								},
								customization: {
									texts: {
										action: 'pay',
										valueProp: 'security_safety',
									},
									visual: {
										hideValueProp: true,
										buttonBackground: 'black', // default, black, blue, white
										valuePropColor: 'grey', // grey, white
										buttonHeight: '48px', // min 48px - max free
										borderRadius: '8px',
										verticalPadding: '16px', // min 16px - max free
										horizontalPadding: '0px', // min 0px - max free
									},
									checkout: {
										theme: {
											// elementsColor: '#222222', // color hex code
											// headerColor: '#222222', // color hex code
										},
									},
								},
								callbacks: {
									onReady: () => {
										/*
										Callback llamado cuando Brick está listo.
										Aquí puedes ocultar loadings de su sitio, por ejemplo.
										*/
									},
									onSubmit: async () => {
										// callback llamado al hacer clic en Wallet Brick
										// esto es posible porque el Brick es un botón
										// en este momento del envío, debe crear la preferencia

										await this.emitir('V');

										if(this.isOkTicketPago){
											return new Promise((resolve, reject) => {
												fetch(process.env.VUE_APP_URL_NODE_MERCADOPAGO + '/create_preference', {
													method: 'POST',
													headers: { 'Content-Type': 'application/json', },
													body: JSON.stringify({ preference: this.preference }),
												})
												.then((response) => response.json())
												.then((response) => {
													// resolver la promesa con el ID de la preferencia
													resolve(response.preferenceId);
												})
												.catch((error) => {
													// manejar la respuesta de error al intentar crear preferencia
													reject();
												});
											});
										}
									},
								},
							};
							window.walletBrickController = await bricksBuilder.create(
								'wallet',
								'walletBrick_container',
								settings,
							);
							
						};
						renderWalletBrick(bricksBuilder);
					});
					document.body.appendChild(script);
				} else {
					if(window.walletBrickController){
						window.walletBrickController.unmount()
					}
				}
			}
		},
		async mounted() {
			this.$store.dispatch('cargando', true);

			await this.getTransaccion();

			if(this.loggedIn){
				await this.datosUsuario();

				if(this.evento && this.evento.Evento.EventoTicketNominado){
					await this.getPreselecciones();
				}
			}

			this.$store.dispatch('cargando', false);
		},
		// beforeRouteLeave (to, from, next) {
		// 	if (this.confirmStay()){
		// 		this.$modal.show('cancelar-transaccion');
		// 		next(false)
		// 	} else {
		// 		next()
		// 	}
		// },
		// created() {
		// 	window.addEventListener('beforeunload', this.beforeWindowUnload)
		// },
		// beforeDestroy() {
		// 	window.removeEventListener('beforeunload', this.beforeWindowUnload)
		// },
		methods: {
			...mapActions('AuthModule', ['logout']),

			// beforeWindowUnload(e) {
			// 	if (this.confirmStay()) {
			// 		// Cancel the event
			// 		e.preventDefault()
			// 		// Chrome requires returnValue to be set
			// 		e.returnValue = ''
			// 	}
			// },
			// confirmStay() {
			// 	return !this.isManualLeave
			// },

			textSearch(e, idx){
				clearTimeout(this.timer)

				this.timer = setTimeout(() => {
					this.calcularSegmento(idx);
				}, 1000)
			},

			soloNumeros ($event) {
				let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
				if (keyCode < 48 || keyCode > 57) {
					$event.preventDefault();
				}
			},
			async promptPreseleccionOpen(index){
				this.$modal.show('promptPreseleccion')
				this.indexTicketPreseleccion = index
			},
			async promptPreseleccionClosed(){
				this.indexTicketPreseleccion = null
			},
			async getPreselecciones(){
				try {
					this.preseleccionYo = null
					this.preseleccionesAmigos = []
					let response = await axios.post('/WSPreselecciones', {
						UsuarioId: this.user.UsuarioId
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if(response.data.ErrorCod === 0){
						this.preseleccionesAmigos = response.data.SDTPreseleccion

						if(Number(response.data.SDTPreseleccionUsuario.PersonaDocumentoTipoId) === 0 && response.data.SDTPreseleccionUsuario.PersonaDocumento === ''){
							this.preseleccionYo = null
						} else {
							this.preseleccionYo = response.data.SDTPreseleccionUsuario
						}
					} else {
						if(response.data.ErrorCod === 1 || response.data.ErrorCod === 10 || response.data.ErrorCod === 11){
							this.logout();
						}
					}
				} catch (error) {
					console.log('Ocurrió un error al obtener tus amigos, intenta nuevamente.')
				}
			},
			async elegirPreseleccion(preseleccion){
				this.tickets[this.indexTicketPreseleccion].PersonaNombre = preseleccion.PersonaNombre
				this.tickets[this.indexTicketPreseleccion].PersonaApellido = preseleccion.PersonaApellido
				this.tickets[this.indexTicketPreseleccion].PersonaDocumentoTipoId = preseleccion.PersonaDocumentoTipoId
				this.tickets[this.indexTicketPreseleccion].PersonaDocumento = preseleccion.PersonaDocumento

				await this.calcularSegmento(this.indexTicketPreseleccion);

				this.$modal.hide('promptPreseleccion')
			},
			async tiposDocumentos(){
				// Obtengo tipos de documento
				try {
					let response = await axios.post('/WSDocumentoTipos', {});

					response.data.SDTDocumentoTipos.forEach((dt) => {
						this.tipoDocumentos.push({ valor: Number(dt.DocumentoTipoId), descripcion: dt.DocumentoTipoNombre });

						if(Number(dt.DocumentoTipoId) === 1){
							this.tipoDocumentoCI = { valor: Number(dt.DocumentoTipoId), descripcion: dt.DocumentoTipoNombre }
						}
					});
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			},
			async datosUsuario(){
				try {
					let response = await axios.post('/WSUsuarioPago', { 
						UsuarioId : this.user.UsuarioId,
						TransaccionId: this.$route.params.transaccionId
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if(response.data.ErrorCod === 0){
						this.usuario = response.data.SDTUsuario
					} else {
						await this.logout();
					}
				} catch (error) {
					await this.logout();
				}
			},
			async getEvento(){
				try {
					let response = await axios.post('/WSEvento', {
						EventoId: this.transaccion.EventoId,
						EventoSlug: this.transaccion.EventoSlug
					});

					if(response.data.ErrorCod === 0){
						this.evento = response.data.SDTEvento
						this.eventoNombre = response.data.SDTEvento.Evento.EventoNombre.trim()
					} else {
						this.$store.dispatch('showError', 'Ocurrió un error. Intenta nuevamente.')
						this.$router.push({ name: 'error' });
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error. Intenta nuevamente.')
					this.$router.push({ name: 'error' });
				}
			},
			async getEventoCampos(){
				this.eventoCampos = []

				try {
					let response = await axios.post('/WSEventoCampos', {
						EventoId: this.transaccion.EventoId
					});

					if(response.data.ErrorCod === 0){
						response.data.SDTEventoCampos.forEach((c) => {
							if(c.EventoCampoEnCanje === true){
								this.eventoCampos.push(c)
							}
						})
					} else {
						this.$store.dispatch('showError', 'Ocurrió un error. Intenta nuevamente.')
						this.$router.push({ name: 'error' });
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error. Intenta nuevamente.')
					this.$router.push({ name: 'error' });
				} finally {
					this.isCargandoEvento = false
				}
			},
			async getTransaccion(){
				try {
					let response = await axios.post('/WSTransaccionObtener', {
						TransaccionId: this.$route.params.transaccionId
					});

					if(response.data.ErrorCod === 0){
						this.transaccion = response.data.SDTTransaccionEvento
						
						let contador = 0;
						let tabIndexContador = 1;

						// Obtener el evento
						await this.getEvento();
						await this.getEventoCampos();
						await this.tiposDocumentos();

						if(Number(this.transaccion.TransaccionCantidad) === Number(this.transaccion.EventoAsientos.length)){
							this.transaccion.EventoAsientos.forEach((t) => {
								let seg = {}
								if(this.evento.Evento.EventoSegmentoElegible){
									seg = this.transaccion.Segmentos.find(s => Number(s.SegmentoId) === Number(t.SegmentoId))
								} else {
									seg = {
										SegmentoId: null,
										SegmentoNombre: '',
										EventoSegmentoInfo: ''
									}
								}

								let campos = []
								this.eventoCampos.forEach((c) => {
									campos.push({
										CampoCod: c.CampoCod,
										TicketCampoValor: null
									})
								})

								contador = contador + 1
								tabIndexContador = contador * (this.eventoCampos.length + 3)

								let ticket = {
									Id: contador,
									SegmentoId: seg.SegmentoId,
									SegmentoNombre: seg.SegmentoNombre,
									EventoSegmentoInfo: seg.EventoSegmentoInfo,
									PersonaNombre: '',
									PersonaApellido: '',
									PersonaDocumentoTipoId: Number(this.tipoDocumentoCI.valor),
									PersonaDocumento: '',
									FilaId: Number(t.Fila),
									AsientoId: Number(t.Asiento),
									Campos: campos,
									TabIndexContador: tabIndexContador,
									RecalculandoSegmento: false
								}

								this.tickets.push(ticket)
							});
						} else {
							this.$store.dispatch('showError', 'Ocurrió un error. Intenta nuevamente.')
							this.$router.push({ name: 'error' });
						}
					} else {
						if(response.data.ErrorCod === 20 || response.data.ErrorCod === 21 || response.data.ErrorCod === 22
						 || response.data.ErrorCod === 30 || response.data.ErrorCod === 31 || response.data.ErrorCod === 40){
							 this.$store.dispatch('showError', 'Ocurrió un error. Intenta nuevamente.')
							this.$router.push({ name: 'home' });
						} else {
							if(response.data.ErrorCod === 42 || response.data.ErrorCod === 41){
								this.cancelarTransaccionId(false);
								this.transaccion = response.data.SDTTransaccionEvento
								this.expiroTiempo = true;
								this.$modal.show('expiro-tiempo')
							} else {
								this.$store.dispatch('showError', 'Ocurrió un error. Intenta nuevamente.')
								this.$router.push({ name: 'error' });
							}
						}
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error. Intenta nuevamente.')
					this.$router.push({ name: 'error' });
				} finally {
					this.isCargandoTransaccion = false
				}
			},
			async cancelarTransaccionOpen(){
				this.$modal.show('cancelar-transaccion');
			},
			// async cancelarTransaccion(redirect){
			// 	try {
			// 		// this.isManualLeave = true;
			// 		let response = await axios.post('/WSTransaccionCancelar',
			// 			{
			// 				UsuarioId : this.user.UsuarioId,
			// 				EventoId: Number(this.transaccion.EventoId),
			// 				Log: 'Checkout'
			// 			},
			// 			{ headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} }
			// 		);

			// 		if(response.data.ErrorCod === 0){
			// 			this.preference = null
			// 			if(redirect){
			// 				this.$router.push({ name: 'home' });
			// 			}
			// 		} else {
			// 			if(response.data.ErrorCod === 1 || response.data.ErrorCod === 20 || response.data.ErrorCod === 21){
			// 				await this.logout();
			// 			} else {
			// 				this.$store.dispatch('showError', 'Ocurrió un error.')
			// 				this.$router.push({ name: 'error' });
			// 			}
			// 		}
			// 	} catch (error) {
			// 		this.$store.dispatch('showError', 'Ocurrió un error.')
			// 		this.$router.push({ name: 'error' });
			// 	}
			// },
			async cancelarTransaccionId(redirectHome){
				try {
					// this.isManualLeave = true;
					let response = await axios.post('/WSTransaccionCancelar2', {
						TransaccionId: this.$route.params.transaccionId
					});

					if(response.data.ErrorCod === 0){
						this.preference = null
						if(redirectHome){
							this.$router.push({ name: 'home' });
						}
					} else {
						this.$store.dispatch('showError', 'Ocurrió un error.')
						this.$router.push({ name: 'error' });
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error.')
					this.$router.push({ name: 'error' });
				}
			},
			async emitir(tipo){
				try {
					this.isOkTicketPago = false
					this.emitiendo = true;
					this.$store.dispatch('cargando', true);

					await this.validacionDatos();

					let usrId = '80ed076b-89de-1899-1899-536d79b70d2a'
					let headers = {}
					if(this.loggedIn){
						usrId = this.user.UsuarioId
						headers = {"Authorization" : `Bearer ${ this.user.AccessToken }`}
					}

					if(this.transaccionTotal > 0){
						// ---------------
						// -- VENTA ------
						// ---------------

						if(this.hayError === false){
							await this.personaValidar();

							if(this.isPersonaValidarOk === true){
								await this.crearOrdenDePagoMP();
								// if(this.initPoint){
								if(this.preference){
									let SDTPersona = [];

									this.tickets.forEach((ticket) => {
										let SDTPersonaItem = {
											PersonaNombre: ticket.PersonaNombre.trim(),
											PersonaApellido: ticket.PersonaApellido.trim(),
											PersonaDocumentoTipoId: Number(ticket.PersonaDocumentoTipoId),
											PersonaDocumento: ticket.PersonaDocumento.trim(),
											SegmentoId: Number(ticket.SegmentoId)
										}

										SDTPersona.push(SDTPersonaItem)
									});

									// Emitir ticket
									let SDTTicket;
									let TicketItems = [];
									let TicketItem;
									let ticketTipo;
									let TicketCampoValor;
									let SDTTicketCampoValores = [];
									let SDTTicketCampoValoresJSON = '';

									this.tickets.forEach((ticket, index) => {
										// Obtener precio
										let segmentoDelTicket = this.segmentosElegidos.find((s) => Number(s.SegmentoId) === Number(ticket.SegmentoId))
										let ticketMonto = parseFloat(segmentoDelTicket.ListaMonto)

										if(ticketMonto === 0){
											ticketTipo = 'C'
										} else {
											if(ticketMonto > 0){
												ticketTipo = 'V'
											} else {
												this.$store.dispatch('showError', 'Ocurrió un error. Intenta nuevamente en unos minutos.')
												this.$router.push({ name: 'error' });
											}
										}

										TicketItem = {
											Id: Number(ticket.Id),
											TicketMonto: ticketMonto,
											TicketTipo: ticketTipo,
											TribunaId: Number(this.transaccion.TransaccionEventoTribunaId),
											SectorCod: this.transaccion.TransaccionEventoSectorCod,
											PersonaNombre: ticket.PersonaNombre.trim(),
											PersonaApellido: ticket.PersonaApellido.trim(),
											PersonaDocumentoTipoId: Number(ticket.PersonaDocumentoTipoId),
											PersonaDocumento: ticket.PersonaDocumento.trim(),
											PersonaTelefono: '',
											SegmentoId: Number(ticket.SegmentoId)
										}

										TicketItems.push(TicketItem);

										// Datos complementarios
										ticket.Campos.forEach((campo) => {
											let value = null;
											let campoActual = this.eventoCampos.find((ec) => ec.CampoCod === campo.CampoCod)
											
											if(campoActual.CampoTipo === 'O'){
												if(campo.TicketCampoValor){
													value = Number(campo.TicketCampoValor.trim())
												}
											} else {
												if(campo.TicketCampoValor && campo.TicketCampoValor.trim() !== ''){
													value = campo.TicketCampoValor.trim()
												}
											}

											if(value){
												TicketCampoValor = {
													Index: Number(index + 1),
													CampoCod: campo.CampoCod,
													TicketCampoValor: value
												}

												SDTTicketCampoValores.push(TicketCampoValor)
											}
										});
									});

									SDTTicketCampoValoresJSON = JSON.stringify(SDTTicketCampoValores);

									SDTTicket = {
										EventoId: Number(this.transaccion.EventoId),
										TransaccionId: this.transaccion.TransaccionId,
										Ticket: TicketItems
									};

									let response = await axios.post('/WSTicketPago', {
										UsuarioId : usrId, 
										SDTTicketJSON: JSON.stringify(SDTTicket), 
										SDTPersonaJSON: JSON.stringify(SDTPersona), 
										MonedaId: Number(this.transaccion.MonedaId), 
										PagoMonto: this.transaccionTotal,
										SDTTicketCampoValoresJSON: SDTTicketCampoValoresJSON,
										TransaccionInvitadoEmail: this.comprador.email.trim(),
										TransaccionInvitadoNombre: this.comprador.nombre.trim(),
										TransaccionInvitadoApellido: this.comprador.apellido.trim(),
										TransaccionInvitadoDocumento: this.comprador.documento.trim(),
										TransaccionInvitadoDocumentoTipo: Number(this.comprador.documentoTipo)
									}, { headers: headers });

									switch(response.data.ErrorCod){
										case 0:
											// window.open(this.initPoint, '_self');
											this.isOkTicketPago = true
											break;
										case 1:
										case 10:
										case 11:
											// this.$store.dispatch('limpiarCheckout');
											this.logout();
											break;
										case 20:
										case 21:
										case 30:
										case 31:
										case 32:
										case 40:
										case 50:
										case 60:
										case 70:
										case 80:
										case 90:
										case 91:
										case 110:
										case 111:
										case 112:
										case 120:
										case 130:
										case 131: 
										case 132: 
										case 133: 
										case 134:
											// this.$store.dispatch('limpiarCheckout');
											this.$router.push({ name: 'error' })
											break;
										case 100:
										case 101:
										case 102:
										case 103:
										case 104:
										case 107:
										case 113:
										case 115:
										case 116:
										case 150:
										case 151:
										case 152:
										case 153:
										case 154:
										case 155:
										case 156:
											this.$store.dispatch('showError', response.data.ErrorDsc);
											break;
										case 500:
											this.$store.dispatch('showError', response.data.ErrorDsc);
											// this.$store.dispatch('limpiarCheckout');
											this.$router.push({ name: 'home' })
											break;
										default:
											// this.$store.dispatch('limpiarCheckout');
											this.$router.push({ name: 'error' })
											break;
									}
								} else {
									this.$store.dispatch('showError', 'Ocurrió un error. Intenta nuevamente en unos minutos.')
									this.$router.push({ name: 'error' });
								}
							}
						} else {
							this.$store.dispatch('showError', this.errorMsg)
						}
					} else {
						if(this.transaccionTotal === 0){
							// ---------------
							// -- CANJE ------
							// ---------------

							if(this.hayError === false){
								await this.personaValidar();

								if(this.isPersonaValidarOk === true){
									let SDTPersona = []

									this.tickets.forEach((ticket) => {
										let SDTPersonaItem = {
											PersonaNombre: ticket.PersonaNombre.trim(),
											PersonaApellido: ticket.PersonaApellido.trim(),
											PersonaDocumentoTipoId: Number(ticket.PersonaDocumentoTipoId),
											PersonaDocumento: ticket.PersonaDocumento,
											SegmentoId: Number(ticket.SegmentoId)
										}

										SDTPersona.push(SDTPersonaItem)
									});

									let SDTTicket;
									let TicketItems = [];
									let TicketItem;
									let ticketTipo;
									let TicketCampoValor;
									let SDTTicketCampoValores = [];
									let SDTTicketCampoValoresJSON = '';

									this.tickets.forEach((ticket, index) => {
										// Obtener precio
										let segmentoDelTicket = this.segmentosElegidos.find((s) => Number(s.SegmentoId) === Number(ticket.SegmentoId))
										let ticketMonto = parseFloat(segmentoDelTicket.ListaMonto)

										if(ticketMonto === 0){
											ticketTipo = 'C'
										} else {
											if(ticketMonto > 0){
												ticketTipo = 'V'
											} else {
												this.$store.dispatch('showError', 'Ocurrió un error. Intenta nuevamente en unos minutos.')
												this.$router.push({ name: 'error' });
											}
										}

										TicketItem = {
											Id: Number(ticket.Id),
											TicketMonto: ticketMonto,
											TicketTipo: ticketTipo,
											TribunaId: Number(this.transaccion.TransaccionEventoTribunaId),
											SectorCod: this.transaccion.TransaccionEventoSectorCod,
											PersonaNombre: ticket.PersonaNombre.trim(),
											PersonaApellido: ticket.PersonaApellido.trim(),
											PersonaDocumentoTipoId: Number(ticket.PersonaDocumentoTipoId),
											PersonaDocumento: ticket.PersonaDocumento.trim(),
											PersonaTelefono: '',
											SegmentoId: Number(ticket.SegmentoId)
										}

										TicketItems.push(TicketItem);

										// Datos complementarios
										ticket.Campos.forEach((campo) => {
											let value = null;
											let campoActual = this.eventoCampos.find((ec) => ec.CampoCod === campo.CampoCod)
											
											if(campoActual.CampoTipo === 'O'){
												if(campo.TicketCampoValor){
													value = Number(campo.TicketCampoValor.trim())
												}
											} else {
												if(campo.TicketCampoValor && campo.TicketCampoValor.trim() !== ''){
													value = campo.TicketCampoValor.trim()
												}
											}

											if(value){
												TicketCampoValor = {
													Index: Number(index + 1),
													CampoCod: campo.CampoCod,
													TicketCampoValor: value
												}

												SDTTicketCampoValores.push(TicketCampoValor)
											}
										});
									});

									SDTTicketCampoValoresJSON = JSON.stringify(SDTTicketCampoValores);

									SDTTicket = {
										EventoId: Number(this.transaccion.EventoId),
										TransaccionId: this.transaccion.TransaccionId,
										Ticket: TicketItems
									};

									let response = await axios.post('/WSTicketCanje', {
										UsuarioId : usrId, 
										SDTTicketJSON: JSON.stringify(SDTTicket), 
										SDTPersonaJSON: JSON.stringify(SDTPersona), 
										SDTTicketCampoValoresJSON: SDTTicketCampoValoresJSON,
										TransaccionInvitadoEmail: this.comprador.email.trim(),
										TransaccionInvitadoNombre: this.comprador.nombre.trim(),
										TransaccionInvitadoApellido: this.comprador.apellido.trim(),
										TransaccionInvitadoDocumento: this.comprador.documento.trim(),
										TransaccionInvitadoDocumentoTipo: Number(this.comprador.documentoTipo)
									}, { headers: headers });

									switch(response.data.ErrorCod){
										case 0:
											this.$router.push({ name: 'canje-exitoso', params: { isOk: 'isok', eventId: Number(this.transaccion.EventoId) } })
											break;
										case 1:
										case 10:
										case 11:
											// this.$store.dispatch('limpiarCheckout');
											this.logout();
											break;
										case 20:
										case 21:
										case 30:
										case 31:
										case 32:
										case 40:
										case 50:
										case 60:
										case 70:
										case 80:
										case 90:
										case 91:
										case 110:
										case 111:
										case 112:
										case 120:
											// this.$store.dispatch('limpiarCheckout');
											this.$router.push({ name: 'error' })
											break;
										case 100:
										case 101:
										case 102:
										case 103:
										case 104:
										case 107:
										case 113:
										case 115:
										case 116:
										case 150:
										case 151:
										case 152:
										case 153:
										case 154:
										case 155:
										case 156:
											this.$store.dispatch('showError', response.data.ErrorDsc);
											break;
										case 500:
											this.$store.dispatch('showError', response.data.ErrorDsc);
											// this.$store.dispatch('limpiarCheckout');
											this.$router.push({ name: 'home' })
											break;
										default:
											// this.$store.dispatch('limpiarCheckout');
											this.$router.push({ name: 'error' })
											break;
									}
								}
							} else {
								this.$store.dispatch('showError', this.errorMsg)
							}
						}
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error. Intenta nuevamente.')
					this.$router.push({ name: 'error' });
				} finally {
					this.emitiendo = false;
					this.$store.dispatch('cargando', false);
				}
			},
			async validacionDatos(){
				this.hayError = false;

				let documentoActual;
				for(let i=0; i<this.tickets.length; i++){
					documentoActual = this.tickets[i].PersonaDocumento.trim();

					if(this.evento.Evento.EventoTicketNominado && this.tickets[i].PersonaNombre.trim().length <= 1){
						this.hayError = true;
						this.errorMsg = 'Ingrese nombre de persona para el ticket ' + this.tickets[i].Id
						break;
					}

					if(this.evento.Evento.EventoTicketNominado && this.tickets[i].PersonaApellido.trim().length <= 1){
						this.hayError = true;
						this.errorMsg = 'Ingrese apellido de persona para el ticket ' + this.tickets[i].Id
						break;
					}

					if(this.evento.Evento.EventoTicketNominado && this.tickets[i].PersonaDocumento.trim().length <= 1){
						this.hayError = true;
						this.errorMsg = 'Ingrese documento de persona para el ticket ' + this.tickets[i].Id
						break;
					}

					for(let m=0; m<this.tickets.length; m++){
						if(this.evento.Evento.EventoTicketNominado && (m !== i) && documentoActual === this.tickets[m].PersonaDocumento){
							this.hayError = true
							this.errorMsg = 'Hay documentos repetidos'
							break;
						}
					}

					// Validación de campos
					for(let k=0; k<this.eventoCampos.length; k++){
						let isCampoObligatorio = this.eventoCampos[k].EventoCampoObligatorio

						if(isCampoObligatorio){
							if(!this.tickets[i].Campos[k].TicketCampoValor && this.eventoCampos[k].CampoTipo === 'O'){
								this.hayError = true
								this.errorMsg = 'Ticket ' + this.tickets[i].Id + ': debes seleccionar ' + this.eventoCampos[k].CampoDescripcion.toLowerCase();
								break;
							}

							if(this.eventoCampos[k].CampoTipo !== 'O'){
								if(!this.tickets[i].Campos[k].TicketCampoValor){
									this.hayError = true
									this.errorMsg = 'Ticket ' + this.tickets[i].Id + ': debes ingresar ' + this.eventoCampos[k].CampoDescripcion.toLowerCase();
									break;
								} else {
									if(this.tickets[i].Campos[k].TicketCampoValor.trim() === ''){
										this.hayError = true
										this.errorMsg = 'Ticket ' + this.tickets[i].Id + ': debes ingresar ' + this.eventoCampos[k].CampoDescripcion.toLowerCase();
										break;
									}
								}
							}
						}


					}
				}
			},
			async personaValidar(){
				this.isPersonaValidarOk = true;

				if(this.evento && !this.evento.Evento.EventoSegmentoElegible){
					try {
						for(let idx = 0; idx<this.tickets.length; idx++){
							let documento = this.tickets[idx].PersonaDocumento.trim()
							let documentoTipo = Number(this.tickets[idx].PersonaDocumentoTipoId)

							let response = await axios.post('/WSSegmentoCalcular', {
								EventoId: this.transaccion.EventoId,
								PersonaDocumentoTipoId: documentoTipo,
								PersonaDocumento: documento
							}, {});

							if(response.data.ErrorCod === 1){
								this.logout();
							} else {
								if(response.data.ErrorCod === 10 || response.data.ErrorCod === 11 || response.data.ErrorCod === 12 || response.data.ErrorCod === 30){
									this.isPersonaValidarOk = false
									this.$store.dispatch('showError', 'Ticket #' + (idx+1) + ': ' + response.data.ErrorDsc)
									break;
								} else {
									if(response.data.ErrorCod === 20 || response.data.ErrorCod === 21){
										this.$store.dispatch('showError', 'Ocurrió un error. Intenta nuevamente.')
										this.$router.push({ name: 'error' });
									} else {
										this.tickets[idx].SegmentoId = response.data.SegmentoId
										this.tickets[idx].SegmentoNombre = response.data.SegmentoNombre
										this.tickets[idx].EventoSegmentoInfo = response.data.EventoSegmentoInfo
									}
								}
							}
						}
					} catch (error) {
						this.$store.dispatch('showError', 'Ocurrió un error. Intenta nuevamente.')
						this.$router.push({ name: 'error' });
					}
				}
			},
			async crearOrdenDePagoMP(){
				try {
					let tit = '';
					let dsc = '';

					if(Number(this.transaccion.TransaccionCantidad) > 1){
						tit = 'Entradas ' + this.evento.Evento.EventoNombre.trim()
						dsc = String(this.transaccion.TransaccionCantidad) + ' entradas para ' + this.evento.Evento.EventoNombre.trim() + ', ' + this.transaccion.TransaccionEventoSectorCod.trim()
					} else {
						tit = 'Entrada ' + this.evento.Evento.EventoNombre.trim()
						dsc = 'Entrada para ' + this.evento.Evento.EventoNombre.trim() + ', ' + this.transaccion.TransaccionEventoSectorCod.trim()
					}

					let trnFechaFin = new Date(this.transaccion.TransaccionFechaFin)
					trnFechaFin.setTime(trnFechaFin.getTime() - (60 * 1000)); // Le resto 60 segundos, para evitar problemas con fechas (demonio cancelación)
					let fchFin = trnFechaFin.getFullYear() + "-" + ('0' + (trnFechaFin.getMonth()+1)).slice(-2) + "-" + ('0' + trnFechaFin.getDate()).slice(-2) + "T" + String(trnFechaFin.getHours()).padStart(2, '0') + ":" + String(trnFechaFin.getMinutes()).padStart(2, '0') + ":" + String(trnFechaFin.getSeconds()).padStart(2, '0') + ".000-03:00"

					let payer = null

					if(this.loggedIn){
						payer = {
							name: this.usuario.UsuarioPersonaNombre.trim(),
							surname: this.usuario.UsuarioPersonaApellido.trim(),
							email: this.usuario.UsuarioEmail.trim(),
							identification: {
								type: Number(this.usuario.UsuarioPersonaDocumentoTipoId),
								number: this.usuario.UsuarioPersonaDocumento.trim()
							}
						}
					} else {
						payer = {
							name: this.comprador.nombre.trim(),
							surname: this.comprador.apellido.trim(),
							email: this.comprador.email.trim(),
							identification: {
								type: Number(this.comprador.documentoTipo),
								number: this.comprador.documento.trim()
							}
						}
					}

					this.preference = {
						binary_mode: true,
						items: [
							{
								id: String(this.transaccion.EventoId) + '-' + String(this.transaccion.TransaccionEventoTribunaId) + '-' + String(this.transaccion.TransaccionEventoSectorCod),
								title: tit,
								currency_id: Number(this.transaccion.MonedaId),
								description: dsc,
								category_id: "tickets",
								quantity: 1,
								unit_price: parseFloat(this.transaccionTotal)
							}
						],
						payer: payer,
						back_urls: {
							success: "",
							failure: ""
						},
						auto_return: "approved",
						payment_methods: {
							excluded_payment_types: [
								{
									id: "ticket"
								}
							],
							// installments: parseInt(this.espectaculo.medioPagoCuotas)
							installments: 1
						},
						notification_url: process.env.VUE_APP_URL_NODE_MERCADOPAGO + "/ipn?source_news=ipn",
						external_reference: String(this.transaccion.EventoId) + "-" + String(this.transaccion.TransaccionId),
						expires: true,
						expiration_date_from: "",
						expiration_date_to: fchFin.trim(),
						statement_descriptor: "LINEUP TICKETS"
					}

					// let response = await axios.post(process.env.VUE_APP_URL_NODE_MERCADOPAGO + '/create_preference', { preference: preference })
					// this.preferenceId = response.data.preferenceId
					// this.initPoint = response.data.initPoint
				} catch (error) {
					console.log('Ocurrió un error al crear la preferencia');
				}
			},
			async expiracionTiempo(){
				this.expiroTiempo = true;

				// this.$store.dispatch('limpiarCheckout');

				this.$modal.show('expiro-tiempo')
				await this.cancelarTransaccionId(false);

				if(window.walletBrickController){
					this.preference = null
					window.walletBrickController.unmount()
				}
			},
			async calcularSegmento(idx){
				if(this.evento && !this.evento.Evento.EventoSegmentoElegible){
					try {
						this.tickets[idx].RecalculandoSegmento = true;

						let documento = this.tickets[idx].PersonaDocumento.trim()
						let documentoTipo = Number(this.tickets[idx].PersonaDocumentoTipoId)

						let response = await axios.post('/WSSegmentoCalcular', {
							EventoId: this.transaccion.EventoId,
							PersonaDocumentoTipoId: documentoTipo,
							PersonaDocumento: documento
						}, {});

						if(response.data.ErrorCod === 1){
							this.logout();
						} else {
							if(response.data.ErrorCod === 12){
								this.$store.dispatch('showError', response.data.ErrorDsc)
								this.tickets[idx].SegmentoId = null
								this.tickets[idx].SegmentoNombre = ''
								this.tickets[idx].EventoSegmentoInfo = ''
							} else {
								if(response.data.ErrorCod === 20 || response.data.ErrorCod === 21){
									this.$store.dispatch('showError', 'Ocurrió un error. Intenta nuevamente.')
									this.$router.push({ name: 'error' });
								} else {
									this.tickets[idx].SegmentoId = response.data.SegmentoId
									this.tickets[idx].SegmentoNombre = response.data.SegmentoNombre
									this.tickets[idx].EventoSegmentoInfo = response.data.EventoSegmentoInfo
								}
							}
						}
					} catch (error) {
						this.$store.dispatch('showError', 'Ocurrió un error. Intenta nuevamente.')
						this.$router.push({ name: 'error' });
					} finally {
						this.tickets[idx].RecalculandoSegmento = false;
					}
				}
			},
			irAEvento(id, slug) {
				this.$router.push({ name: 'evento', params: { eventSlug: slug, eventId: id } });
			},
			logIn() {
				this.$store.dispatch("AuthModule/showAuthModal", {
					callbackAction: {
						name: "AuthModule/redirigirAWithReload",
						payload: {
							// route: "home",
							route: this.$route.name,
							params: { transaccionId: this.$route.params.transaccionId },
						},
					},
				});
			},
		}
	}
</script>

<style>
	#walletBrick_container{
		width: 100% !important;
		margin: 8px 0px 0px 0px !important;
	}

	#walletBrick_container div{
		margin: 0px !important;
	}

	#walletBrick_container button{
		background-color: #222222 !important;
		font-size: 14px !important;
		font-weight: var(--fw-600) !important;
		font-family: var(--font-sora) !important;
		line-height: 1.4em !important;
    	letter-spacing: 1px !important;
	}
</style>

<style lang="scss" scoped>
	#checkout-page{
		background-color: var(--color-white);
		@include flex(column, flex-start, flex-start);
		padding: 60px 0px;
		min-height: calc(100vh - 80px);

		.container{
			max-width: 960px;
			@include flex(row, space-between, flex-start);

			.checkout-main{
				width: calc(100% - 440px);
				@include flex(column, flex-start, flex-start);
				padding-right: 40px;

				.countdown{
					margin-bottom: 20px;
				}

				.checkout-main-top{
					width: 100%;
					@include flex(row, space-between, center);

					.checkout-main-top-left{
						@include flex(column, center, flex-start);

						.title{
							font-size: 18px;
							font-family: var(--font-sora);
							font-weight: var(--fw-700);
						}

						p{
							margin-top: 3px;
							font-size: 13px;
						}

						.iniciar-sesion{
							font-weight: var(--fw-700);
							text-decoration: underline;
							cursor: pointer;
							@include transition(all .2s);

							&:hover{
								opacity: 0.9;
							}
						}
					}

					.checkout-main-top-right{
						@include flex(column, center, flex-end);

						// .tiempo-restante{
						// 	@include flex(row, space-between, center);
						// 	padding: 4px 8px;
						// 	background-color: #ccc;
						// 	border-radius: 22px;
						// 	font-weight: var(--fw-600);
						// 	font-size: 13px;
						// 	width: 72px;

						// 	i{
						// 		margin-right: 3px;
						// 	}
						// }

						// .tiempo-restante-aclaracion{
						// 	font-size: 11px;
						// 	margin-top: 5px;
						// 	font-weight: var(--fw-400);
						// 	line-height: 1em;
						// }
					}
				}

				.checkout-main-comprador{
					width: 100%;
					@include flex(row, space-between, center);
					margin: 20px 0px;

					.comprador{
						width: 100%;
						padding-bottom: 20px;
						@include flex(column, flex-start, flex-start);
						border: 1px solid var(--color-grey);
						border-radius: 8px;
						position: relative;

						.comprador-row-nominado{
							width: 100%;
							@include flex(column, flex-start, flex-start);
						}

						.comprador-row-nominado{
							padding-top: 6px;
						}

						.comprador-row{
							width: 100%;
							padding: 0px 20px;
							@include flex(column, flex-start, flex-start);

							.input-group{
								width: 100%;
								margin: 8px 0px 4px 0px;
								position: relative;
								@include flex(column, flex-start, flex-start);

								label {
									font-size: 13px;
									font-weight: var(--fw-600);
									margin-top: 0px;
									margin-bottom: 5px;
									line-height: 1em;
								}

								span{
									font-size: 14px;
									line-height: 1.4em;
									font-weight: var(--fw-400);
								}

								input {
									-webkit-appearance: none;
									appearance: none;
									border: none;
									width: 100%;
									padding: 0px 14px 0px 14px;
									font-size: 14px;
									font-weight: var(--fw-400);
									line-height: 1.4em;
									width: 100%;
									border-radius: 8px;
									height: 44px;
									outline: none;
									box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset;
									// box-shadow: 0 0 #0000,0 0 #0000, 0 1px 2px 0 rgba(0,0,0,.05);

									&::placeholder {
										color: #9aa5b5;
										opacity: 1;
									}

									&:-ms-input-placeholder {
										color: #9aa5b5;
									}

									&::-ms-input-placeholder {
										color: #9aa5b5;
									}

									&:focus-within {
										@include transition(all 0.2s);
										box-shadow: #222 0px 0px 0px 2px inset;

										&.form-input--error {
											box-shadow: var(--color-red-error) 0px 0px 0px 2px inset;
										}
									}

									&.form-input--error {
										box-shadow: var(--color-red-error) 0px 0px 0px 1px inset;
									}
								}

								input:-webkit-autofill,
								input:-webkit-autofill:hover,
								input:-webkit-autofill:focus {
									border: none;
									-webkit-text-fill-color: var(--color-darker);
									box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset, 0 0 0px 1000px transparent inset;
									-webkit-box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset, 0 0 0px 1000px transparent inset;

									&:focus-within {
										box-shadow: rgb(34, 34, 34) 0px 0px 0px 2px inset, 0 0 0px 1000px transparent inset;
									}
								}

								.input-group-aux{
									width: 100%;
									margin: 0px;
									position: relative;
									@include flex(row, flex-start, center);

									select{
										position: absolute;
										top: 50%;
										left: 2px;
										transform: translateY(-50%);
										@include sinApariencia();
										width: 44%;
										height: calc(100% - 4px);
										background-image: url('../assets/ChevronUpDown.svg');
										background-repeat: no-repeat;
										background-size: 18px;
										background-position: right 5px center;
										font-family: var(--font-inter);
										font-weight: var(--fw-500);
										font-size: 12px;
										border: none;
										padding: 0 14px;
										border-radius: 8px 0px 0px 8px;
										border-right: 1px solid #b0b0b0;
									}

									input{
										width: 100%;
										padding-left: calc(44% + 14px);
									}
								}
							}

							&.comprador-row-alerta-datos{
								.comprador-alerta{
									width: 100%;
									@include flex(row, flex-start, center);
									background-color: #e8e9eb;
									border: 1px solid #e8e9eb;
									border-radius: 8px;
									outline: none;
									padding: 7px 12px;
									margin: 10px 0px;

									i{
										font-size: 16px;
										margin-right: 10px;
									}

									span{
										font-size: 11px;
										color: var(--color-darker);
										font-weight: var(--fw-500);
										line-height: 1.45em;
									}
								}
							}
						}
					}
				}

				.checkout-main-content{
					width: 100%;
					display: grid;
					grid-template-columns: repeat(1, 1fr);
					grid-auto-rows: 1fr;
					grid-column-gap: 0px;
					grid-row-gap: 20px;
					margin: 20px 0px 70px 0px;
					
					.ticket{
						width: 100%;
						padding-bottom: 20px;
						@include flex(column, flex-start, flex-start);
						// border: 1px solid #222222;
						// transform: translate(-0.25rem, -0.25rem);
						// box-shadow: 0.25rem 0.25rem 0 #222222;
						border: 1px solid var(--color-grey);
						border-radius: 8px;
						position: relative;

						.recalculando-segmento{
							position: absolute;
							background-color: rgba(255, 255, 255, 0.9);
							width: 100%;
							height: 100%;
							border-radius: 8px;
							@include flex(column, center, center);
							z-index: 9;
						}

						.ticket-top{
							width: 100%;
							padding: 0px;
							height: 60px;
							@include flex(row, flex-start, center);
							border-bottom: 1px solid #ccc;
							// margin-bottom: 14px;

							.ticket-top-left{
								position: absolute;
								left: -80px;
								width: 60px;
								height: 60px;
								// border-right: 1px solid #ccc;
								@include flex(column, center, flex-end);

								.ticket-text{
									font-size: 11px;
									line-height: 1em;
									margin-bottom: 4px;
									font-family: var(--font-sora);
									font-weight: var(--fw-600);
									color: var(--color-grey);
								}

								.ticket-id{
									font-weight: var(--fw-600);
									line-height: 1em;
									font-size: 22px;
									color: var(--color-grey);
								}
							}
							
							.ticket-top-right{
								padding-left: 14px;
								@include flex(column, center, flex-start);

								.sector{
									font-weight: var(--fw-700);
									font-family: var(--font-sora);
									font-size: 14px;
									line-height: 1em;
								}

								.sector-info{
									font-weight: var(--fw-400);
									font-family: var(--font-sora);
									font-size: 13px;
									line-height: 1em;
									margin-top: 7px;
								}

								.sector-calcular-aclarar{
									color: #9aa5b5;
									font-size: 12px;
								}
							}
						}

						.ticket-row-nominado, .ticket-row-campos{
							width: 100%;
							@include flex(column, flex-start, flex-start);
						}

						.ticket-row-nominado{
							// border-top: 1px solid #ccc;
							// margin-top: 14px;
							padding-top: 6px;
						}

						.ticket-row{
							width: 100%;
							padding: 0px 20px;
							@include flex(column, flex-start, flex-start);

							&.row-multiple{
								@include flex(row, space-between, center);

								.input-group{
									width: 50%;
								}
							}

							&.ticket-row-alerta-datos{
								.preseleccion-alerta{
									width: 100%;
									@include flex(row, flex-start, center);
									background-color: #e8e9eb;
									border: 1px solid #e8e9eb;
									border-radius: 8px;
									outline: none;
									padding: 7px 12px;
									margin: 10px 0px;
									@include transition(all 0.2s);
									cursor: pointer;

									i{
										font-size: 16px;
										margin-right: 10px;
									}

									span{
										font-size: 11px;
										color: var(--color-darker);
										font-weight: var(--fw-500);
										line-height: 1.45em;
									}
								}
							}

							.input-group{
								width: 100%;
								margin: 8px 0px 4px 0px;
								position: relative;
								@include flex(column, flex-start, flex-start);

								label {
									font-size: 13px;
									font-weight: var(--fw-600);
									margin-top: 0px;
									margin-bottom: 5px;
									line-height: 1em;
								}

								span{
									font-size: 14px;
									line-height: 1.4em;
									font-weight: var(--fw-400);
								}

								input {
									-webkit-appearance: none;
									appearance: none;
									border: none;
									width: 100%;
									padding: 0px 14px 0px 14px;
									font-size: 14px;
									font-weight: var(--fw-400);
									line-height: 1.4em;
									width: 100%;
									border-radius: 8px;
									height: 44px;
									outline: none;
									box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset;
									// box-shadow: 0 0 #0000,0 0 #0000, 0 1px 2px 0 rgba(0,0,0,.05);

									&::placeholder {
										color: #9aa5b5;
										opacity: 1;
									}

									&:-ms-input-placeholder {
										color: #9aa5b5;
									}

									&::-ms-input-placeholder {
										color: #9aa5b5;
									}

									&:focus-within {
										@include transition(all 0.2s);
										box-shadow: #222 0px 0px 0px 2px inset;

										&.form-input--error {
											box-shadow: var(--color-red-error) 0px 0px 0px 2px inset;
										}
									}

									&.form-input--error {
										box-shadow: var(--color-red-error) 0px 0px 0px 1px inset;
									}
								}

								select{
									@include sinApariencia();
									width: 100%;
									height: 44px;
									background-image: url('../assets/ChevronUpDown.svg');
									background-repeat: no-repeat;
									background-size: 18px;
									background-position: right 5px center;
									font-size: 14px;
									font-weight: var(--fw-400);
									line-height: 1.4em;
									outline: none;
									border: none;
									box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset;
									padding: 0 14px;
									border-radius: 8px;
									padding: 0px 36px 0px 14px;
									cursor: pointer;

									&:focus{
										box-shadow: rgb(34, 34, 34) 0px 0px 0px 2px inset, 0 0 0px 1000px transparent inset;
									}
								}

								input:-webkit-autofill,
								input:-webkit-autofill:hover,
								input:-webkit-autofill:focus,
								textarea:-webkit-autofill,
								textarea:-webkit-autofill:hover,
								textarea:-webkit-autofill:focus,
								select:-webkit-autofill,
								select:-webkit-autofill:hover,
								select:-webkit-autofill:focus {
									border: none;
									-webkit-text-fill-color: var(--color-darker);
									box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset, 0 0 0px 1000px transparent inset;
									-webkit-box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset, 0 0 0px 1000px transparent inset;

									&:focus-within {
										box-shadow: rgb(34, 34, 34) 0px 0px 0px 2px inset, 0 0 0px 1000px transparent inset;
									}
								}

								.input-group-aux{
									width: 100%;
									margin: 0px;
									position: relative;
									@include flex(row, flex-start, center);

									select{
										position: absolute;
										top: 50%;
										left: 2px;
										transform: translateY(-50%);
										@include sinApariencia();
										width: 44%;
										height: calc(100% - 4px);
										background-image: url('../assets/ChevronUpDown.svg');
										background-repeat: no-repeat;
										background-size: 18px;
										background-position: right 5px center;
										font-family: var(--font-inter);
										font-weight: var(--fw-500);
										font-size: 12px;
										border: none;
										padding: 0 14px;
										border-radius: 8px 0px 0px 8px;
										border-right: 1px solid #b0b0b0;
									}

									input{
										width: 100%;
										padding-left: calc(44% + 14px);
									}
								}
							}

							button.preseleccionar-button{
								@include flex(row, center, center);
								background-color: #e8e9eb;
								border: 1px solid #e8e9eb;
								border-radius: 8px;
								outline: none;
								padding: 7px 12px;
								color: var(--color-darker);
								font-size: 10px;
								font-weight: var(--fw-600);
								font-family: var(--font-sora);
								line-height: 1.2em;
								letter-spacing: 0.5px;
								text-transform: uppercase;
								margin: 10px 0px;
								@include transition(all 0.2s);
								cursor: pointer;

								&:hover {
									opacity: 0.9;
									border-color: var(--color-darker);
								}

								i{
									font-size: 16px;
									margin-right: 5px;
								}
							}
						}
					}
				}
			}

			aside{
				position: relative;
				width: 440px;
				@include flex(column, flex-start, center);

				.aside-wrapper{
					position: relative;
					@include flex(column, flex-start, flex-start);
					border-radius: 22px;
					box-shadow: rgba(0, 0, 0, 0.12) 0px 6px 16px;
					border: 1px solid rgba(0, 0, 0, 0.1);
					margin-bottom: 20px;

					.aside-top{
						width: 100%;
						border-radius: 22px 22px 0px 0px;
						@include flex(column, flex-start, flex-start);
						position: relative;
						padding: 30px 30px 76px 30px;
						background-color: var(--color-darker);
						background-position: center;
						background-size: cover;
						background-repeat: no-repeat;

						.evento-title{
							color: var(--color-white);
							font-family: var(--font-sora);
							font-weight: var(--fw-700);
							font-size: 22px;
							line-height: 1.4em;
							z-index: 2;
						}

						.aside-top-info{
							position: absolute;
							width: calc(100% - 60px);
							height: 112px;
							bottom: -56px;
							left: 30px;
							background-color: var(--color-white);
							// z-index: 99;
							border-radius: 12px;
							padding: 14px;
							box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 22px;
							z-index: 10;
							@include flex(row, flex-start, center);

							.evento-foto{
								border-radius: 12px;
								height: 80px;
								width: 80px;
								object-fit: cover;
								margin-right: 20px;
							}

							.aside-top-info-right{
								@include flex(column, center, flex-start);

								.evento-info-categoria{
									font-weight: var(--fw-700);
									line-height: 1em;
									font-size: 12px;
								}

								.evento-info-fecha{
									font-weight: var(--fw-400);
									line-height: 1em;
									margin-top: 5px;
									font-size: 13px;
								}

								.evento-info-escenario{
									font-weight: var(--fw-400);
									line-height: 1em;
									margin-top: 5px;
									font-size: 13px;
								}
							}
						}

						&:before{
							content: '';
							position: absolute;
							background: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.3));
							top: 0;
							left: 0;
							width: 100%;
							height: 100%;
							z-index: 0;
							border-radius: 22px 22px 0px 0px;
						}
					}

					.aside-main{
						width: 100%;
						@include flex(column, flex-start, flex-start);
						padding: 80px 30px 30px 30px;
						position: relative;
						z-index: 4;

						.aside-row{
							width: 100%;
							@include flex(row, space-between, center);

							&.aside-row-item{
								margin: 1px 0px;
							}

							&.aside-row-concepto{
								margin: 5px 0px;
							}

							&.aside-row-concepto-total{
								margin: 8px 0px;
							}

							&.aside-row-terminos{
								width: 100%;
								margin-top: 15px;
								@include flex(column, flex-start, center);

								.terminos {
									font-size: 11px;
									text-align: center;
									width: 100%;
									padding-bottom: 15px;
									line-height: 1.5em;
									color: #9aa5b5;

									a {
										color: var(--color-darker);
										font-weight: var(--fw-600);
									}
								}
							}

							.divider{
								position: relative;
								width: 100%;
								height: 1px;
								border-top: 1px dashed rgba(0, 0, 0, 0.25);
								margin: 16px 0px;
							}

							.resumen-text{
								font-size: 17px;
								font-weight: var(--fw-300);
								margin-bottom: 16px;
								line-height: 1em;
							}

							.sector-text{
								font-size: 14px;
								font-weight: var(--fw-600);
								line-height: 1em;
								margin-bottom: 5px;
							}

							.sector-text-info{
								font-size: 13px;
								font-weight: var(--fw-300);
								margin-bottom: 5px;
							}

							.item, .item-monto{
								font-size: 13px;
								font-weight: var(--fw-400);
								line-height: 1.4em;
								margin-top: 3px;
							}

							.concepto-subtotal, .concepto-comision, .monto-subtotal, .monto-comision{
								font-family: var(--font-sora);
								font-size: 13px;
								font-weight: var(--fw-400);
								line-height: 1em;
							}

							.concepto-total, .monto-total{
								font-family: var(--font-sora);
								font-size: 18px;
								font-weight: var(--fw-600);
								line-height: 1em;
							}

							button{
								@include flex(row, center, center);
								width: 100%;
								background-color: #222222;
								border: 1px solid #222222;
								border-radius: 8px;
								outline: none;
								padding: 13px 22px;
								color: var(--color-white);
								font-size: 14px;
								font-weight: var(--fw-600);
								font-family: var(--font-sora);
								line-height: 1.4em;
								letter-spacing: 1px;
								margin: 8px 0px 0px 0px;
								@include transition(all 0.2s);
								cursor: pointer;

								&:hover {
									// background-color: var(--color-black);
									background-color: var(--color-primary);
									border: 1px solid #222222;
									color: #222222;
									transform: translate(-0.25rem, -0.25rem);
									box-shadow: 0.25rem 0.25rem 0 #222222;
								}

								&:disabled {
									background-color: #e8e9eb;
									color: var(--color-darker);
									border-color: #e8e9eb;
									cursor: not-allowed;

									&:hover {
										background-color: #e8e9eb;
										border: 1px solid #e8e9eb;
										color: var(--color-darker);
										transform: none;
										box-shadow: none;
									}
								}

								.emitiendo-loader{
									margin-left: 10px;
									margin-bottom: -3px;
								}
							}
						}

						.aside-bottom{
							width: 100%;
							@include flex(column, flex-start, flex-start);
							margin-top: 20px;

							.aside-bottom-row{
								width: 100%;
								@include flex(row, flex-start, flex-start);

								.check-icon{
									@include flex(row, center, center);
									margin-right: 14px;
									border-radius: 99px;
									background-color: #04ab70;
									width: 22px;
									height: 22px;

									i{
										color: var(--color-white);
										font-size: 18px;
									}
								}
								
								.aside-bottom-group{
									width: calc(100% - 36px);
									@include flex(column, center, flex-start);

									.aside-bottom-title{
										font-size: 13px;
										font-weight: var(--fw-700);
										font-family: var(--font-sora);
										margin-bottom: 8px;
										line-height: 1em;
										margin-top: 3px;
									}

									.aside-bottom-text{
										font-size: 11px;
										font-weight: var(--fw-400);
										// font-family: var(--font-sora);
										line-height: 1.3em;
									}
								}
							}
						}
					}
				}

				.cancelar-transaccion{
					@include flex(row, space-between, center);
					margin-bottom: 20px;
					border-bottom: 1px solid rgba(0, 0, 0, 0.1);
					font-size: 13px;
					line-height: 1em;
					padding-bottom: 4px;
					@include transition(all .2s);
					cursor: pointer;

					&:hover{
						color: var(--color-red-error);
						border-bottom-color: var(--color-red-error);
					}
				}
			}

			.evento-loader{
				padding: 60px 40px 60px 0px;
				@include flex(row, center, center);
				width: 100%;
			}
		}
	}

	@media screen and (max-width: 1400px){
		#checkout-page{
			.container{
				padding-left: 24px;
				padding-right: 24px;
			}
		}
	}

	@media screen and (max-width: 1300px){
		#checkout-page{
			padding: 30px 0px;

			.container{
				.checkout-main{
					width: calc(100% - 410px);
					padding-right: 20px;
				}
				
				aside{
					width: 410px;
				}
			}
		}
	}

	@media screen and (max-width: 1180px){
		#checkout-page{
			.container{
				@include flex(column, flex-start, flex-start);

				.checkout-main{
					width: 100%;
					padding-right: 0px;

					.checkout-main-content{
						margin: 20px 0px 30px 0px;
					}
				}
				
				aside{
					width: 440px;
					margin: 0 auto;
				}
			}
		}
	}

	@media screen and (max-width: 866px){
		#checkout-page{
			.container{
				.checkout-main{
					.checkout-main-top{
						.checkout-main-top-left{
							padding-right: 20px;
						}

						.checkout-main-top-right{
							.tiempo-restante-aclaracion{
								display: none;
							}
						}
					}

					.checkout-main-content{
						grid-template-columns: repeat(1, 1fr);
						margin: 20px auto 20px auto;
						max-width: 440px;

						.ticket{
							max-width: 440px;
						}
					}
				}
				
				aside{
					width: 440px;
					margin: 0 auto;
				}
			}
		}
	}

	@media screen and (max-width: 620px){
		#checkout-page{
			.container{
				.checkout-main{
					.checkout-main-content{
						max-width: unset;

						.ticket{
							max-width: unset;
							width: calc(100% - 50px);
							margin-left: 50px;

							.ticket-top{
								.ticket-top-left{
									left: -80px;
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 460px){
		#checkout-page{
			.container{
				.checkout-main{
					.checkout-main-content{
						.ticket{
							.ticket-row .input-group .input-group-aux select{
								width: 60%;
							}

							.ticket-row .input-group .input-group-aux input{
								padding-left: calc(60% + 14px);
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 536px){
		#checkout-page{
			.container{
				// .checkout-main{
				// 	.checkout-main-content{
				// 		max-width: unset;

				// 		.ticket{
				// 			max-width: unset;
				// 			width: 100%;
				// 		}
				// 	}
				// }

				aside{
					width: 100%;
					margin: 0;

					.aside-wrapper{
						.aside-top{
							padding: 20px 20px 56px 20px;

							.evento-title{
								font-size: 18px;
							}

							.aside-top-info{
								height: 92px;
								bottom: -46px;
								width: calc(100% - 40px);
								left: 20px;
								padding: 12px;

								.evento-foto{
									width: 68px;
									height: 68px;
									border-radius: 8px;
									margin-right: 12px;
								}

								.aside-top-info-right{
									.evento-info-categoria{
										font-size: 11px;
									}

									.evento-info-fecha{
										font-size: 12px;
									}

									.evento-info-escenario{
										font-size: 12px;
									}
								}
							}
						}

						.aside-main{
							padding: 80px 20px 20px 20px;

							.aside-row{
								.resumen-text{
									font-size: 15px;
									margin-bottom: 12px;
								}

								.sector-text{
									font-size: 13px;
								}

								.sector-text-info{
									font-size: 12px;
								}

								.item{
									font-size: 12px;
									font-weight: var(--fw-500);
								}

								.item-monto{
									font-size: 12px;
									font-weight: var(--fw-500);
								}

								.divider{
									margin: 12px 0px;
								}

								.concepto-subtotal{
									font-size: 12px;
								}

								.monto-subtotal{
									font-size: 12px;
								}

								.concepto-comision{
									font-size: 12px;
								}

								.monto-comision{
									font-size: 12px;
								}

								.concepto-total{
									font-size: 15px;
								}

								.monto-total{
									font-size: 15px;
								}

								button{
									padding: 11px 20px;
									font-size: 13px;
								}
							}
						}
					}
				}
			}
		}
	}
</style>